module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyMatch: 'Beauty Match',
        beautyMatches: 'Beauty Matches'
    };
    return resources[label];
};
